module.exports = __webpack_public_path__ + "static/media/entree-coffeetable.26321698.svg";